module.exports = __webpack_public_path__ + "img/b4aedd9.png";